import { styled } from '@mui/material/styles';
import { AppBar, Toolbar } from '@mui/material';
import { HEADER, NAVBAR } from 'src/config';
import cssStyles from '../../utils/cssStyles';

export const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  height: HEADER.MOBILE_HEIGHT,
  transition: theme.transitions.create(['height', 'background-color'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('md')]: {
    height: HEADER.MAIN_DESKTOP_HEIGHT,
  },
}));

export const ToolbarShadowStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  height: 24,
  zIndex: -1,
  margin: 'auto',
  borderRadius: '50%',
  position: 'absolute',
  width: `calc(100% - 48px)`,
  boxShadow: theme.customShadows.z8,
}));

type RootStyleProps = {
  isCollapse: boolean;
  isOffset: boolean;
  verticalLayout: boolean;
};

export const HeaderRootStyle = styled(AppBar, {
  shouldForwardProp: (prop) =>
    prop !== 'isCollapse' && prop !== 'isOffset' && prop !== 'verticalLayout',
})<RootStyleProps>(({ isCollapse, isOffset, verticalLayout, theme }) => ({
  ...cssStyles(theme).bgBlur({ color: theme.palette.common.white }),
  backgroundColor: theme.palette.common.white,
  borderBottom: '1px solid rgba(145, 158, 171, 0.12)',
  boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.08), 0 8px 16px -4px rgba(145, 158, 171, 0.12)',
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  transition: theme.transitions.create(['width', 'height', 'box-shadow'], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('lg')]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH + 1}px)`,
    ...(isCollapse && {
      width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
    }),
    ...(isOffset && {
      boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.12), 0 12px 24px -4px rgba(145, 158, 171, 0.16)',
    }),
    ...(verticalLayout && {
      width: '100%',
      backgroundColor: theme.palette.common.white,
    }),
  },
}));
